var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"plotContainer",staticClass:"plot-container"}),(_vm.error)?_c('el-alert',{attrs:{"title":_vm.error,"type":"error","show-icon":""}}):_vm._e(),(_vm.loading)?_c('el-alert',{attrs:{"title":"Loading...","type":"info","show-icon":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }